import { render, staticRenderFns } from "./VirtualAccountFreightBillMethod.vue?vue&type=template&id=66d9ce35"
import script from "./VirtualAccountFreightBillMethod.vue?vue&type=script&lang=js"
export * from "./VirtualAccountFreightBillMethod.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountFreightBillMethod.vue?vue&type=style&index=0&id=66d9ce35&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d9ce35')) {
      api.createRecord('66d9ce35', component.options)
    } else {
      api.reload('66d9ce35', component.options)
    }
    module.hot.accept("./VirtualAccountFreightBillMethod.vue?vue&type=template&id=66d9ce35", function () {
      api.rerender('66d9ce35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VirtualAccountFreightBillMethod.vue"
export default component.exports